import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  token: null,
  profile: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.profile = action.payload.profile;
    },
    clearCredentials: (state) => {
      state.profile = null;
    },
    setToken: (state, action) => {
      state.token = action.payload.token;
    },
    clearToken: (state) => {
      state.token = null;
    },
  },
});

export const { setCredentials, clearCredentials,setToken,clearToken } = authSlice.actions;
export default authSlice.reducer;
